var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.srcImage)?_c('div',{staticClass:"image round",style:(("border: solid " + _vm.borderSize + "px " + _vm.borderColor + ";"))},[_c('img',{staticClass:"round",attrs:{"src":_vm.srcImage,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }